import {ActionLink, StatusLink} from 'components/ui/DbLink'
import {CONTRIBUTORS} from 'data/CONTRIBUTORS'

export const changelog = [
	{
		date: new Date('2026-01-13'),
		Changes: () => <>Fix chakra gauge tracking for patch 7.4 logs</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2025-04-11'),
		Changes: () => <>Update Enlightenment target count for patch 7.2</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2025-04-11'),
		Changes: () => <>Add a 10-GCD target for <StatusLink status="BROTHERHOOD" /> windows. It is technically possible to get 11 GCDs in Brotherhood, but this is extremely tight at the standard 1.94 GCD.</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-12-12'),
		Changes: () => <>Add a chakra gauge to the timeline and suggestions for overcapping chakra. Gauge events are only visible to the logging player, so these won't show up unless the Monk was the player who uploaded this log.</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-11-19'),
		Changes: () => <>Refine the suggestion for overwritten <StatusLink status="FORMLESS_FIST" /> applications to ignore downtime</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-11-19'),
		Changes: () => <>Refine the suggestion for bad actions used during <StatusLink status="RIDDLE_OF_FIRE" /> windows to ignore downtime</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-11-19'),
		Changes: () => <>Refine the suggestion for Nadi overcap to only show when a use of <ActionLink action="PHANTOM_RUSH" /> was lost</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-11-12'),
		Changes: () => <>Mark Monk as supported for patch 7.1</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-07-29'),
		Changes: () => <>Mark Monk as supported for patch 7.01</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-07-29'),
		Changes: () => <>Add checklist items and suggestions for maximizing Opo-opo GCDs</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-07-26'),
		Changes: () => <>Fix incorrect icon on <ActionLink action="SHADOW_OF_THE_DESTROYER" /></>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-07-25'),
		Changes: () => <>Add Fury Gauge graph and suggestions for overcapped Fury</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-07-25'),
		Changes: () => <>Add Nadi tracking for <ActionLink action="ELIXIR_BURST" /> and pre-upgrade Blitz actions</>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-07-25'),
		Changes: () => <>Add suggestions for dropped uses of <ActionLink action="FIRES_REPLY" /> and <ActionLink action="WINDS_REPLY" /></>,
		contributors: [CONTRIBUTORS.HINT],
	},
	{
		date: new Date('2024-07-04'),
		Changes: () => <>Initial data scaffolding for Dawntrail</>,
		contributors: [CONTRIBUTORS.HINT],
	},
]
